import { useState, useEffect } from "react";
import * as React from "react";
// import * as React from "react";
// import { Word } from "@microsoft/office-js";
import { useAppContext } from '../MSGraph/AppContext';
import { PrimaryButton, Panel, ChoiceGroup, IChoiceGroupOption, TextField, Spinner, SpinnerSize, Label, PanelType } from "@fluentui/react";
import { OpenAIClient, AzureKeyCredential } from "@azure/openai";
import {IconButton, initializeIcons, IPivotStyles, Link, Pivot, PivotItem } from "office-ui-fabric-react";
import ClauseLibrary from "./ClauseLibrary";
import { SweetAlerts } from "./Global/SweetAlert";
import NewClause from "./NewClause";
import './Home.css';
import { ChevronDown16Regular } from "@fluentui/react-icons";
import { CopilotExtractText } from "./Generators/CopilateTextExtractor";
function AlternateClauseAI() {
    const app = useAppContext();
    const AiStars : any = require("../../../assets/AiStars.png")
    const [selectedText, setSelectedText] = useState("");
    const [textchoices, settextchoices] = React.useState([]);
    const [replacetext, setreplacetext] = React.useState<any>();
    const [loading, setLoading] = React.useState<any>();
    const [isPanelOpen, setIsPanelOpen] = useState(false)
    const [messagechoices, setmessagechoices] = React.useState([]);
    const [ClauseModal, setClauseModal] = useState(false);
    const [newClause, setnewClause] = useState(false);
    const [showSelected, setShowSelected] = useState(false);
    const [selectedPivot, setSelectedPivot] = useState('Cluase');
    const [contentNotFound, setContentNotFound] = useState(false);
    const [selectedMessage, setSelectedMessage] = React.useState<string | undefined>('');
    const [call, setCall] = useState({
      AI:true, library:true
    })
    const [message, setMessage] = React.useState({
        defaultmessages:[], altmessages:[]
      })
    const [showAltMessages, setShowAltMessages] = useState(false);
    const { SweetAlert: Sweetalert,SweetPrompt:SweetPromptPanel } = SweetAlerts("#Sweetaler");
    const AzureAI:any= JSON.parse(localStorage.getItem("AzureAI")||"{}")
    const Copilot:any= JSON.parse(localStorage.getItem("Copilot")||"{}")
    const [ButtonSaveList, setButtonSaveList] = React.useState<string>(
       "Get From AI"
      );
    const pivotStyles: Partial<IPivotStyles> = {
        link: {
          marginRight: 0,
        },
      };
      React.useEffect(() => {
        if (message && message?.defaultmessages) {
          setmessagechoices(message.defaultmessages || []);
        }
        initializeIcons()
      }, [message]);
    useEffect(() => {
        const selectionChangedHandler = async () => {
            const textFromWord = await getSelectedText();
            setSelectedText(textFromWord);
        };
        const intervalId = setInterval(selectionChangedHandler);
        return () => clearInterval(intervalId);
    }, [selectedText]);

    async function getSelectedText() {
        try {
            return await Word.run(async (context) => {
                // Get the current selection
                // console.log("inside doc selection");
                const selection = context.document.getSelection();
                selection.load("text");
                // Synchronize with Word
                await context.sync();
                setSelectedText(selection.text);
                // console.log("Selected Text:", selection.text);
                return selection.text; // Return the selected text
            });
        } catch (error) {
            console.error("Error getting selected text:", error);
            return ""; // Return empty string in case of error
        }
    }
    const getdatafromAI = async (selectiontext) => {
      const AzureAI:any= JSON.parse(localStorage.getItem("AzureAI")||"{}")
      const endpoint =AzureAI?.Endpoint //"https://clmai.openai.azure.com/";
      const azureApiKey =AzureAI?.APIkey // "C9S9ksGyYrdvO0womECNX5OecmEpf6fOeesgVQJ5H7w3RNQtOMHJJQQJ99AKACYeBjFXJ3w3AAABACOGkAw9";
      const deploymentName = AzureAI?.DeploymentName//"gpt-35-turbo";
        // const endpoint = "https://clmai.openai.azure.com/"//JSON.parse(AzureApiData)?.Endpoint || "";//EndPointValue;
        // const azureApiKey = "C9S9ksGyYrdvO0womECNX5OecmEpf6fOeesgVQJ5H7w3RNQtOMHJJQQJ99AKACYeBjFXJ3w3AAABACOGkAw9"//JSON.parse(AzureApiData)?.APIkey || ""//AzureApiKeyValue;
        try {
          if(selectiontext?.trim()?.length){
            setCall((pre) => ({ ...pre, AI: false }))
            // setButtonSaveList("")
            setSelectedPivot('From AI')
            setLoading(true)
            setIsPanelOpen(true)
            const allCompletions = [];
            if(AzureAI?.AzureOpenAIToggle){
            const client = new OpenAIClient(endpoint, new AzureKeyCredential(azureApiKey));
            const deploymentId = deploymentName ;//JSON.parse(AzureApiData)?.DeploymentName || ""// DeploymentNameValue;
            let array = []
            // convList?.map(x =>
            array.push({
                role: "user", content: selectiontext
            })
            // )

            // if (array.length == 0) {
            //   array.push({
            //     role: "user", content: defaultMessage
            //   })

            // }
            array.push(
                {
                    role: 'system',
                    content: "You are a helpful assistant who provides concise and direct answers. Avoid stating that you are an AI language model."
                },
                {
                    role: 'system',
                    content: "Please rephrase the content to more proffessional"
                }
            )
            // console.log(props.Comments)

            // Loop to generate multiple completions
            for (let i = 0; i < 4; i++) {
                const result = await client.getChatCompletions(deploymentId, array, {
                    temperature: 0.5, //tone
                    maxTokens: 200 // font size
                });
                allCompletions.push(result.choices); // Store each completion
            }
            // console.log(allCompletions, "allCompletions")
          } else if(Copilot?.CopilotToggle === "Yes"){
            const result = await CopilotExtractText(selectiontext, "Alternate Clause");
            try {
              const parsed = JSON.parse(result);
              if (parsed) {
                allCompletions.push(...parsed);
                setContentNotFound(false)
              }
            } catch (e) {
              setContentNotFound(true)
              console.log("Non result:", result);
            }
          }
            let allItems1ForAI = []
            for (const choice of allCompletions) {
                let finaltemp = {
                    key: choice[0]?.message?.content || choice,
                    text: choice[0]?.message?.content || choice,
                    Message: choice[0]?.message?.content || choice,

                };

                allItems1ForAI.push(finaltemp);
            }
            settextchoices(allItems1ForAI);
            // console.log(textchoices, "textchoices");
            setLoading(false);
            setButtonSaveList("Get From AI")
          }
          else{
            Sweetalert('error','Please select text from editor')
          }
        }
        catch (err) {
            console.log(err)
        }

    }

    function onChangeConditions(ev: React.FormEvent<HTMLInputElement>, option: IChoiceGroupOption): void {
        console.dir(ev);
        if (option) {
          setreplacetext(option.text as string);
          setSelectedMessage(option.text as string)
        }
        //setselectednewtext('')
      }

      function handleSelectClick() {
        setShowSelected(true);
      }
    const replaceSelectedText = async () => {
        try {
          await Word.run(async (context) => {
            const selection = context.document.getSelection();
            selection.insertText(replacetext||selectedMessage, "Replace"); // Replace selected text
            await context.sync();
            settextchoices([]);
            setSelectedText("");
            closePanel();
          });
        } catch (error) {
          console.error("Error replacing text:", error);
        }
      };
      function handleOnchange (_, newValue){
        // console.log(e)
       setSelectedText(newValue)
      }
      const handleTextFieldChange = (e) => {
        if(selectedPivot !=='Cluase'){
        setreplacetext(e.target.value);
        }
        else{
          setSelectedMessage(e.target.value)
        }
      };
      const handleClauseLibrary =()=>{
        if(selectedText?.trim()?.length){
        setIsPanelOpen(true)
        setClauseModal(true)
        setSelectedPivot('Cluase')
        } else{
          Sweetalert('error','Please select text from editor')
        }
      }
      const handlePivotChange = (item) => {
        setSelectedPivot(item.props.itemKey)
        setSelectedMessage('')
        setShowSelected(false)
        setreplacetext("")
        if(item.props.itemKey=="Cluase"){
          if(call.library){
          setCall((pre) => ({ ...pre, library: false }))
          setClauseModal(true)
        }}
        else if(item.props.itemKey=="From AI"){
          if(call.AI){
          getdatafromAI(selectedText)
          setCall((pre) => ({ ...pre, AI: false }))
          setSelectedMessage('')
        }
      }
      };
      const toggleAltMessages = () => {
        if (showAltMessages) {
          setmessagechoices(message.defaultmessages || []);
        } else {
          setmessagechoices([
            ...(message.defaultmessages || []),
            ...(message.altmessages || [])
          ]);
        }
        setShowAltMessages(!showAltMessages);
      };
      const closePanel = () =>{
        setIsPanelOpen(false);
        setMessage({defaultmessages:[], altmessages:[]}),
        settextchoices([]);
        setCall({library:true, AI:true});
        setShowSelected(false);
        setSelectedMessage('');
        setreplacetext('');
        setClauseModal(false);
        setnewClause(false)
      }
    return (
      <div>
        {/* <PrimaryButton onClick={getSelectedText} text="Click here getting text from document" /> */}
        <Label required> Text from Editor </Label>
        <TextField
          multiline
          // label={'Select Text From Editor'}
          placeholder={"Select text from editor"}
          style={{ width: "100%", padding: "5px" }}
          value={selectedText || ""}
          rows={8}
          onChange={handleOnchange}
          //type="text"
          // value={selectedText}
          // readOnly
          // placeholder="Select text in Word..."
          // style={{ width: "100%", marginTop: "10px", padding: "5px" }}
          // rows={8}
          // onChange={(e) => setSelectedText(e.target.value)}
        />
        {!isPanelOpen && (
          <div
            style={{ display: "flex", marginTop: "12px", flexDirection: "column", gap: "10px", alignItems: "center" }}
          >
            <PrimaryButton
              text="Get From Clause Library"
              onClick={() => {
                handleClauseLibrary(), setCall((pre) => ({ ...pre, library: false }));
              }}
            />
            {(AzureAI?.Endpoint && AzureAI?.DeploymentName && AzureAI?.APIkey && AzureAI?.AzureOpenAIToggle || Copilot?.CopilotToggle ==='Yes') && <PrimaryButton
              onClick={() => {
                getdatafromAI(selectedText);
              }}
              style={{
                      width: "193px",
                      background: "linear-gradient(45deg, #daeaf6, #e8def8, #fdf0f0, #e8def8, #daeaf6)",
                      color: "black",
                      fontWeight: "400",
                      border: "none"
                    }}
            >
              {ButtonSaveList}
              <img src={AiStars} alt="AI Stars" width={20} height={20} style={{marginLeft:'5px'}}/>
            </PrimaryButton>}
          </div>
        )}
     {  isPanelOpen&& <Panel
          className="panelAIClause"
          isOpen={isPanelOpen}
          onDismiss={closePanel}
          type={PanelType.smallFixedFar}
          headerText="Search Alternative Clause(s)"
          headerTextProps={{ style: { fontSize: "16px" } }}
        >
          <div id="Sweetaler">
          <Label> Selected Text: </Label>
          <TextField multiline value={selectedText} readOnly style={{ width: "100%", padding: "5px" }} rows={8} />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Pivot selectedKey={selectedPivot} onLinkClick={handlePivotChange} styles={pivotStyles}>
              <PivotItem
                headerText={selectedPivot === "Cluase" ? "From Clause Library" : "Get From Clause Library"}
                itemKey="Cluase"
              >
                <div id="UpdateDocEditorDiv26" style={{minWidth:'16.5rem'}}>
                  {showSelected ? (
                    <TextField
                      multiline
                      label={"Selected Text:"}
                      value={selectedMessage || ""}
                      autoAdjustHeight
                      onChange={handleTextFieldChange}
                    />
                  ) : message.altmessages.length || message.defaultmessages.length ? (
                    <>
                      <ChoiceGroup options={messagechoices} onChange={onChangeConditions} value={selectedMessage} />
                      {message.altmessages.length > 0 && (
                        <Link onClick={toggleAltMessages} style={{ marginTop: "10px" }}>
                          {showAltMessages ? "Hide alternative clause(s)" : "Click here to get alternative clause(s)"}
                        </Link>
                      )}
                    </>
                  ) : (
                    <>
                      <div>Clause not found</div>
                      <PrimaryButton text="Enter own text" onClick={handleSelectClick} style={{ marginTop: "1rem" }} />
                    </>
                  )}
                </div>
                {replacetext && !showSelected && (
                  <PrimaryButton text={"Select"} onClick={handleSelectClick} style={{ marginTop: "1rem" }} />
                )}
                {showSelected && (
                  <PrimaryButton
                    onClick={replaceSelectedText}
                    text="Replace in Contract"
                    style={{ marginTop: "10px" }}
                  />
                )}
              </PivotItem>
              {(AzureAI?.Endpoint && AzureAI?.DeploymentName && AzureAI?.APIkey && AzureAI?.AzureOpenAIToggle || Copilot?.CopilotToggle ==='Yes') &&
              <PivotItem headerText={selectedPivot === "From AI" ? "From AI" : "Get From AI"} itemKey="From AI"  onRenderItemLink={(link, defaultRenderer) => (
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  {defaultRenderer?.(link)}
                  <img src={AiStars} alt="AI Stars" width={25} height={25} />
                </span>
              )}>
                {loading ? (
                  <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
                    <Spinner size={SpinnerSize.small} label="Please wait..." />
                  </div>
                ) : contentNotFound ? (
                  <div className='NoDataFound'>No data found</div>
                ) : (
                  <>
                    <div id="UpdateDocEditorDiv28">
                      {showSelected ? (
                        <TextField
                          multiline
                          label={"Selected Text:"}
                          value={replacetext || ""}
                          autoAdjustHeight
                          onChange={handleTextFieldChange}
                        />
                      ) : (
                        <ChoiceGroup options={textchoices} onChange={onChangeConditions} />
                      )}
                    </div>
                    {replacetext && !showSelected && (
                      <PrimaryButton text={"Select"} onClick={handleSelectClick} style={{ marginTop: "1rem" }} />
                    )}
                    {showSelected && (
                      <div
                        style={{
                          display: "flex",
                          marginTop: "12px",
                          flexDirection: "column",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <PrimaryButton
                          onClick={replaceSelectedText}
                          text="Replace in Contract"
                          style={{ width: "260px" }}
                          className="customPrimaryButton"  />

                        <PrimaryButton onClick={()=>setnewClause(true)}
                         text="Replace in Contract & Add in Clause Library"
                         style={{ width: "260px" }}
                         className="customPrimaryButton" />
                      </div>
                    )}
                  </>
                )}
              </PivotItem>}
            </Pivot>
            {showSelected && (
              <IconButton
                iconProps={{ iconName: "ChevronDownn" }}
                styles={{
                  rootHovered: {
                    backgroundColor: 'transparent',
                  },
                  rootPressed: {
                    backgroundColor: 'transparent',
                  },
                }}
                onClick={() => {
                  setShowSelected(false), setSelectedMessage(""), setreplacetext("");
                }}>
                <ChevronDown16Regular style={{marginTop:'16px', marginLeft:'-24px'}}/>
              </IconButton>
            )}
          </div>
          {ClauseModal && (
            <ClauseLibrary open={ClauseModal} onClose={() => setClauseModal(false)} setMessage={setMessage} />
          )}
          {newClause && 
            <Panel
              // id="Sweetaler2"
              isOpen={newClause}
              onDismiss={() => {
                setnewClause(false);
              }}
              type={PanelType.smallFixedFar}
              headerText="Add Clause"
              headerTextProps={{ style: { fontSize: "16px" } }}
            >
              <NewClause Cluase={replacetext} closepanel={replaceSelectedText} setnewClause={setnewClause}/>
            </Panel>
          }
           </div>
        </Panel>}
      </div>
    );
};

export default AlternateClauseAI;
